
<div class="modal-header">
	<h2 class="modal-title">{{ title }}</h2>
	<button type="button" class="modal-button-close fal fa-times" (click)="onClose()"></button>
</div>
<div class="modal-body">
	<history [selectedHistorique]="selectedHistorique"> </history>
</div>
<div class="modal-footer">
	
</div>


